import { Toast } from '@ymba/ym-ui';

window.addEventListener('offline', () => {
  Toast('当前网络不稳定');
});
